// extracted by mini-css-extract-plugin
export default {"title-desc":"SignUpScreen_title-desc__SeEbc","signup":"SignUpScreen_signup__u6l2Q","signin":"SignUpScreen_signin__vkR2X"};